import { createFileRoute } from '@tanstack/react-router';
import { Stack } from '@mantine/core';
import { PageHeader } from '../../../../components/PageHeader';
import { RunsTable } from '../../../../features/production-packconv/components/RunsTable';

/** All-runs register (BUILD_SPEC.md §11 "registers ... runs"). */
export const Route = createFileRoute('/_authenticated/production-packconv/runs/')({
  component: RunsRegisterPage,
});

function RunsRegisterPage() {
  return (
    <Stack gap="lg">
      <PageHeader
        title="Runs"
        description="Continuous production runs — inputs, consumables and outputs for each shift."
      />
      <RunsTable title="All runs" />
    </Stack>
  );
}
